import { render } from "./Compte.vue?vue&type=template&id=2b1338be&scoped=true"
import script from "./Compte.vue?vue&type=script&lang=js"
export * from "./Compte.vue?vue&type=script&lang=js"

import "./Compte.vue?vue&type=style&index=0&id=2b1338be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1338be"]])

export default __exports__